function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Production_svg__29_a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#4DB1FD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#148CFC"
})));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "url(#Production_svg__29_a)",
  fillRule: "evenodd",
  d: "M183.379 11.21a1.5 1.5 0 011.848-2.116 9 9 0 11-1.848 2.116zm.876.723a7.875 7.875 0 101.805-2.066 1.5 1.5 0 01-1.805 2.066zm6.102.172a12.816 12.816 0 00-.51 3.369h2.307a12.788 12.788 0 00-.511-3.37 3.976 3.976 0 00-1.286 0zm-1.194.4a3.95 3.95 0 00-2.076 2.969h1.707c.015-1 .14-1.996.37-2.969zm1.193 7.39a3.976 3.976 0 001.288 0c.318-1.09.49-2.218.51-3.369h-2.308c.019 1.14.19 2.274.51 3.37zm-1.194-.4a13.757 13.757 0 01-.369-2.969h-1.706a3.95 3.95 0 002.075 2.968zm.67-8.358a5.014 5.014 0 012.355.005 5.002 5.002 0 01.058 9.702.526.526 0 01-.136.033 5.017 5.017 0 01-2.218 0 .526.526 0 01-.136-.033 5.002 5.002 0 01.076-9.707zm3.005 1.368c.231.978.355 1.976.37 2.969h1.706a3.95 3.95 0 00-2.076-2.969zm.001 6.99a3.95 3.95 0 002.075-2.969h-1.707a13.82 13.82 0 01-.368 2.968z",
  transform: "translate(-182 -7)"
});

var SvgProduction = function SvgProduction(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref, _ref2);
};

export default SvgProduction;